import styles from './RemoteBadge.module.scss'

/** Faz-45: Index çalışanı bayiye remote bağlanıp sordu; rozet bayinin yanında gösterilir. */
export const REMOTE_BADGE_TOOLTIP = 'Index çalışanı bayiye remote bağlanıp sordu'

interface RemoteBadgeProps {
  /** Verilirse "Remote: N" (bayi / kırılım satırı); verilmezse tek tur / tek oy satırı için "Remote". */
  count?: number
  testId?: string
}

/**
 * Remote oturum rozeti. Sayı verilip 0 ise hiçbir şey çizmez: "Deneme Kartı Hariç" açıkken remote turlar
 * zaten sayılmadığından rozet doğal olarak yalnız filtre kapalıyken görünür.
 */
export const RemoteBadge = ({ count, testId }: RemoteBadgeProps) => {
  if (count !== undefined && count <= 0) return null

  const label = count === undefined ? 'Remote' : `Remote: ${count.toLocaleString('tr-TR')}`
  const tooltip = count === undefined ? REMOTE_BADGE_TOOLTIP : `${count.toLocaleString('tr-TR')} tur: ${REMOTE_BADGE_TOOLTIP}`

  return (
    <span className={styles.remoteBadge} title={tooltip} aria-label={tooltip} data-testid={testId}>
      {label}
    </span>
  )
}
